module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-lightest col-sm-12 py-2"
  }, [(!_vm.showPromocodeWindow) ? _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('div', {
    staticClass: "d-flex flexGrow1 text-uppercase d-flex flex-column"
  }, [_c('div', {
    staticClass: "dark bold"
  }, [_vm._v("Discount")]), _vm._v(" "), (_vm.enablePromocode && !_vm.validPromocode) ? _c('div', {
    staticClass: "color-1 pointer",
    on: {
      "click": function($event) {
        return _vm.togglePromocodeWindow('open')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-plus-circle"
  }), _vm._v(" Add Promocode")]) : _vm._e(), _vm._v(" "), (_vm.validPromocode) ? _c('div', {
    staticClass: "bold color-1 d-flex",
    class: {
      'color-6': _vm.showPromocodeInvalid
    }
  }, [_vm._v(_vm._s(_vm.validPromocode.code))]) : _vm._e()]), _vm._v(" "), (_vm.showPromocodeInvalid) ? _c('div', {
    staticClass: "bold color-6 mr-5"
  }, [_vm._v("Invalid Code")]) : _vm._e(), _vm._v(" "), (!_vm.validPromocode) ? _c('div', {
    staticClass: "d-flex justify-content-end align-items-center"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.reservation.attachDiscount.value),
      expression: "reservation.attachDiscount.value",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "glued-right px-2 py-1 text-right",
    staticStyle: {
      "width": "70px"
    },
    attrs: {
      "type": "number",
      "disabled": _vm.noTicketsSelected,
      "placeholder": "0"
    },
    domProps: {
      "value": (_vm.reservation.attachDiscount.value)
    },
    on: {
      "change": _vm.discountChanged,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation.attachDiscount, "value", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "glued-left border-left-light py-1 px-2 pointer",
    class: {
      'notAllowed dark': _vm.noTicketsSelected
    },
    attrs: {
      "disabled": _vm.noTicketsSelected
    },
    on: {
      "click": _vm.switchDiscountType
    }
  }, [_vm._v(_vm._s(_vm.reservation.attachDiscount.valueType == 1 ? '%' : '€'))])])]) : _vm._e(), _vm._v(" "), (_vm.validPromocode) ? _c('div', {
    staticClass: "d-flex justify-content-end align-items-center"
  }, [_c('i', {
    staticClass: "fas fa-times dark pointer fs-larger",
    on: {
      "click": function($event) {
        return _vm.removePromocode()
      }
    }
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.validPromocode.value + (_vm.validPromocode.amountType == 0 ? '€' : '%')))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showPromocodeWindow) ? _c('div', {
    staticClass: "row floatPrmocodeWindow"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "row d-flex align-items-center mt-2"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 d-flex justify-content-end"
  }, [_c('i', {
    staticClass: "fas fa-times dark pointer",
    on: {
      "click": function($event) {
        return _vm.togglePromocodeWindow('close')
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 mt-2"
  }, [(_vm.showPromocodeInvalid) ? _c('span', {
    staticClass: "color-6"
  }, [_vm._v("Invalid code, please try again.")]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempPromocode),
      expression: "tempPromocode"
    }],
    staticClass: "fs-large text-center w-100",
    class: {
      'border-color-6': _vm.showPromocodeInvalid
    },
    attrs: {
      "type": "text",
      "placeholder": "ex: PROMO10"
    },
    domProps: {
      "value": (_vm.tempPromocode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tempPromocode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn blue w-100 wide mt-2",
    on: {
      "click": _vm.applyCode
    }
  }, [_vm._v("Apply")])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-8"
  }, [_c('span', {
    staticClass: "text-uppercase dark bold"
  }, [_vm._v("Insert your promocode")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-7fdd15b0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fdd15b0"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/promocode/promocodeInput.vue
// module id = 2854
// module chunks = 0